export const telefoneMask = {
    brasil: ['+55 (##) #####-####','+55 (##) ####-####'],
    paraguai: ['+595 ### ### ###','+595 ### ### ###'],
    argentina: ['+54 ### ### ###','+54 ### ### ###']
}

export const documentosMask = {
    cpf: '###.###.###-##',
    cnpj: '##.###.###/####-##',
    ruc: '########-#'
}


export const codigoPostalMask = {
    brasil: '#####-###',
    paraguai: '#####-###',
}